import React from "react";
import "../style/ChooseVersion.css";
import { getComaPrice, makespaceline } from "../module/simple";
import LocationBasedPrice from "./location_based_car_price";

function ChooseVersion({ props }) {
  const datas = props.state.car.varients;
  const baseUrl = "https://testkalyaniadmin.kalyanimotors.com/storage/";
  // 6 product
  //1 Color

  for (let i = 0; i < datas.length; i++) {
    if (i < datas[i].products.length) {
      datas[i]["varientColor"] = i;
    } else {
      datas[i]["varientColor"] = 0;
    }
  }

  // console.log('as', datas);
  return (
    <>
      {datas && (
        <div>
          <h1 className="mainHeading">Related Model Variants...</h1>
          <div className="mainContainer">
            {datas.map((item, idx) => {
              return item.products[item.varientColor] ? (
                <div
                  className="versionContainer"
                  key={idx}
                  onClick={(e) =>
                    (window.location =
                      "/car/" +
                      makespaceline(item.products[0].route + "/" + idx))
                  }
                >
                  <div className="imgCont">
                    <img
                      src={
                        item.products.length > 0 && item.varientColor ? (
                          baseUrl +
                          item.products[item.varientColor].images[0] ? (
                            baseUrl +
                            item.products[item.varientColor].images[0].images
                          ) : (
                            <h4>No Data</h4>
                          )
                        ) : (
                          baseUrl +
                          item.products[item.varientColor].images[0].images
                        )
                      }
                      alt="Kalyanimotors Leading Maruti Suzuki Dealership"
                    />
                  </div>
                  <div className="dataCont">
                    <p className="title">{item.var_title}</p>
                    <div className="price">
                      <LocationBasedPrice item = {item} variant={true}/>
                    </div>
                    {/* <h4 className="Ex_price">Ex-Showroom Price</h4> */}
                    	<div 
									style={{
										maxWidth: "300px",
										// lineHeight: "2em",
										// height: "3em",
										overflow: "hidden",
										textOverflow: "ellipsis",
										display: "-webkit-box",
										WebkitBoxOrient: "vertical",
										WebkitLineClamp: 2,
									  fontSize:"11px",
                    marginTop:'6px',
                    marginBottom : '6px',
									}}>
									{item.about_car}
								</div>
                  </div>
                </div>
              ) : null;
            })}
          </div>
        </div>
      )}
    </>
  );
}

export default ChooseVersion;
